module.exports = __webpack_public_path__ + "img/gifn2.3cb77ddf.gif";